import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./Components/ErrorBoundary";
import { logFrontendError } from "./Services/errorLogger";

export function registerGlobalErrorHandlers() {
  window.addEventListener("error", (event) => {
    logFrontendError({
      source: "window.error",
      error: event.error || new Error(event.message || "Unknown window error"),
      extra: {
        message: event.message || null,
        filename: event.filename || null,
        lineno: event.lineno || null,
        colno: event.colno || null,
      },
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;

    let error;

    if (reason instanceof Error) {
      error = reason;
    } else {
      error = new Error(typeof reason === "string" ? reason : "Unhandled promise rejection");
    }

    logFrontendError({
      source: "window.unhandledrejection",
      error,
      extra: {
        reason:
          typeof reason === "object" && reason !== null
            ? JSON.stringify(reason, getCircularReplacer())
            : String(reason),
      },
    });
  });
}

function getCircularReplacer() {
  const seen = new WeakSet();

  return (_, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return "[Circular]";
      }
      seen.add(value);
    }
    return value;
  };
}

registerGlobalErrorHandlers();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
